export enum PriorityEnum {
  NORMAL = "NORMAL",
  MAJOR = "MAJOR",
  CRITICAL = "CRITICAL",
  UNSET = "UNSET"
}